// extracted by mini-css-extract-plugin
export default {"wrapper":"MapForm_wrapper__sRIWl","refreshButton":"MapForm_refreshButton__NgCZ8"};